export const titles = {
    PAYCOR: 'Paycor',
    TALENYA: 'Talenya',
};
export const favicons = {
    PAYCOR: '/public/favicon_paycor.png',
    TALENYA: '/public/favicon.png',
};
